export default {
	SPACE_MIX: 'companies/:company_id/space-mix/',
	SPACE_MIX_CONFIRM:'companies/:company_id/onboarding/spacemix-data',
	MIGRATION:'companies/:company_id/onboarding/onboarding-property/',
	BEGINMERGE:'companies/:company_id/onboarding/merge-begin/',
	UPDATESTATUS:'companies/:company_id/onboarding/update-onboarding-status/'
}
